import { Button, Paper, Backdrop, Box, Typography, Divider, Stack, styled } from '@mui/material';
import { keyframes } from '@mui/system';

const slideUp = keyframes`
  from { transform: translateY(12px); opacity: 0; }
  to   { transform: translateY(0);    opacity: 1; }
`;

/* Backdrop wrapper */
export const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  alignItems: 'flex-end',
  justifyContent: 'flex-end',
  padding: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    padding: 0
  }
}));

/* Main container paper */
export const ClarityPaper = styled(Paper)(({ theme }) => ({
  width: 'min(520px, calc(100% - 32px))',
  maxWidth: '100%',
  borderRadius: 12,
  padding: theme.spacing(2),
  boxShadow: '0 10px 30px rgba(0,0,0,.2)',
  background: '#fff',
  transform: 'translateY(12px)',
  opacity: 0,
  animation: `${slideUp} 160ms ease-out forwards`,
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  }
}));

/* Header grid with icon + text */
export const HeaderBox = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(2),
  gridTemplateColumns: 'auto 1fr',
  alignItems: 'center'
}));

/* Icon wrapper */
export const CookieIconWrapper = styled('div')(({ theme }) => ({
  display: 'block',
  marginRight: theme.spacing(1),
  '& svg, & img': {
    height: 64,
    width: 64,
    [theme.breakpoints.down('sm')]: {
      height: 48,
      width: 48
    }
  }
}));

/* Consent text */
export const ConsentText = styled(Typography)(() => ({
  color: '#222',
  margin: 0,
  lineHeight: 1.5
}));

/* Divider with margin */
export const ConsentDivider = styled(Divider)(({ theme }) => ({
  margin: theme.spacing(1, 0)
}));

/* Actions stack (buttons) */
export const ActionsStack = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'stretch'
  }
}));

/* Styled primary button */
export const StyledButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(1, 3),
  minWidth: 100
}));
